import { jsx } from "react/jsx-runtime";
import styled, { keyframes } from "styled-components";
function Spinner(props) {
  return /* @__PURE__ */ jsx(Svg, {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ...props,
    children: /* @__PURE__ */ jsx(Circle, {
      cx: "12",
      cy: "12",
      r: "8",
      fill: "none",
      strokeWidth: "3"
    })
  });
}
const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;
const dash = keyframes`
  0% {
    stroke-dasharray: 1, 100;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 80, 100;
    stroke-dashoffset: -20;
  }

  100% {
    stroke-dasharray: 80, 100;
    stroke-dashoffset: -48;
  }
`;
const Svg = styled.svg.withConfig({
  displayName: "Svg",
  componentId: "sc-5lftme-0"
})(["width:24px;height:24px;animation:", " 1s linear infinite;"], rotate);
const Circle = styled.circle.withConfig({
  displayName: "Circle",
  componentId: "sc-5lftme-1"
})(["stroke:currentcolor;animation:", " 1.5s ease-in-out infinite;stroke-linecap:round;"], dash);
export {
  Spinner
};
//# sourceMappingURL=Spinner.js.map
